import React from 'react';
import PageEnvelope from '../elements/PageEnvelope';
import CommunityPanel from '../elements/CommunityPanel';
import { Server } from 'src/server/server';
import { NavLink } from 'react-router-dom';
import { BsPlusLg, BsSearch } from 'react-icons/bs';
import './SitePage.css'
import './DashboardPage.css'

interface DashboardPageState {
  loading: boolean;
}

class DashboardPage extends React.Component<{}, DashboardPageState> {
  constructor(props: {}) {
    super(props);
    this.state = {
      loading: true
    }
  }

  componentDidMount(): void {
    this.loadCommunities();
  }

  async loadCommunities() {
    let communities = Server.user.getCommunities();

    if(communities.length > 0) {
      let ids = [];
      for(let i = 0; i < communities.length; i++) 
        ids.push(communities[i].id);
      await Server.public.loadCommunities(ids);
    }

    this.setState({loading: false})
  }

  onVisit(community:any) {
    let url = window.location.host;
    if(url.indexOf('www') == 0)
      url = url.replace('www', community.slug)
    else
      url = community.slug + '.' + url;

    url = window.location.protocol + '//' + url;

    window.open(url, '_blank');
  }

  renderCommunities(host:boolean) {
    let communities = Server.user.getCommunities();

    let filteredCommunities = [];
    for(let i = 0; i < communities.length; i++) {
      let community = Server.public.getCommunity(communities[i].id);

      if(community.host == Server.user.getId() && !host)
        continue;

      if(community.host != Server.user.getId() && host)
        continue;

      filteredCommunities.push(community);
    }

    return (
      <div className="site-page-column">
        {filteredCommunities.length == 0 ? 'None yet.' : 
          filteredCommunities.map((community, i) => (
            <CommunityPanel 
              key={i} 
              community={community} 
              onVisit={this.onVisit.bind(this)} 
            />
          ))
        }
      </div>
    )
  }

  render() {
    return (
      <div className="site-page">
        <PageEnvelope width="500px">
          <div className="site-page-column">

            <div>Communities you have created:</div>
            {this.state.loading ? <div className="site-page-panel">Loading...</div> : this.renderCommunities(true)}

            <div style={{textAlign: 'right'}}>
              <NavLink to="/create">
                <button>
                  <div style={{display: 'flex', alignItems: 'center', textDecoration: 'none'}}><BsPlusLg/>&nbsp;Create</div>
                </button>
              </NavLink>
            </div>

            <div style={{marginTop: '10px'}}>Communities you have joined:</div>
            {this.state.loading ? <div className="site-page-panel">Loading...</div> : this.renderCommunities(false)}

            <div style={{textAlign: 'right'}}>
              <NavLink to="/join">
                <button>
                  <div style={{display: 'flex', alignItems: 'center', textDecoration: 'none'}}><BsSearch/>&nbsp;&nbsp;Search</div>
                </button>
              </NavLink>
            </div>
          </div>
        </PageEnvelope>
      </div>
    )
  }
}

export default DashboardPage;